import dateFormat from "dateformat";
import i18next from "i18next";

const _ = require("lodash");

export const deepCompare = (value1, value2) => {
  if (value1 === null && value2 === null) return true;
  else if (value1 === undefined && value2 === undefined) return true;

  return _.isEqual(value1, value2);
};

// export const beep = () => {
//     var snd = new Audio("data:audio/wav;base64,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");
//     snd.play();
// }
const myAudioContext = new AudioContext();

export const beep = (duration, frequency, volume) => {
  return new Promise((resolve, reject) => {
    // Set default duration if not provided
    duration = duration || 200;
    frequency = frequency || 440;
    volume = volume || 100;

    try {
      let oscillatorNode = myAudioContext.createOscillator();
      let gainNode = myAudioContext.createGain();
      oscillatorNode.connect(gainNode);

      // Set the oscillator frequency in hertz
      oscillatorNode.frequency.value = frequency;

      // Set the type of oscillator
      oscillatorNode.type = "square";
      gainNode.connect(myAudioContext.destination);

      // Set the gain to the volume
      gainNode.gain.value = volume * 0.01;

      // Start audio with the desired duration
      oscillatorNode.start(myAudioContext.currentTime);
      oscillatorNode.stop(myAudioContext.currentTime + duration * 0.001);

      // Resolve the promise when the sound is finished
      oscillatorNode.onended = () => {
        resolve();
      };
    } catch (error) {
      reject(error);
    }
  });
};

export const beepFile = (url, volume = 100) => {
  return new Promise((resolve, reject) => {
    volume = volume || 100;

    try {
      let soundSource = url;
      let sound = new Audio(soundSource);

      // Set volume
      sound.volume = volume / 100;

      sound.onended = () => {
        resolve();
      };

      sound.play();
    } catch (error) {
      reject(error);
    }
  });
};

export const isEmptyObject = (obj) =>
  Object.keys(obj).length === 0 && obj.constructor === Object; //obj && typeof obj === "object" && Object.keys(obj).length === 0;

export const shortenNumber = (value, decimalPlaces = 2) => {
  if (isNaN(parseFloat(value.toString()))) return "";

  let isDecimal = value.toString().indexOf(".") >= 0;

  value = parseFloat(value);

  if (value < 1000 && value > -1000)
    return value.toFixed(isDecimal ? decimalPlaces : 0).toString();

  value = value.toFixed(0);

  if (value < 1000000 && value > -1000000) {
    value = value / 1000;
    isDecimal = value.toString().indexOf(".") >= 0;
    return value.toFixed(isDecimal ? decimalPlaces : 0) + " K";
  } else if (value < 1000000000 && value > -1000000000) {
    value = value / 1000000;
    isDecimal = value.toString().indexOf(".") >= 0;
    return value.toFixed(isDecimal ? decimalPlaces : 0) + " M";
  } else {
    value = value / 1000000000;
    isDecimal = value.toString().indexOf(".") >= 0;
    return value.toFixed(isDecimal ? decimalPlaces : 0) + " B";
  }
};

export const formatNumberWithCommas = (value, decimalPlaces) => {
  if (isNaN(parseFloat(value))) return "";

  let isDecimal = value.toString().indexOf(".") >= 0;

  if (isDecimal) value = value.toFixed(decimalPlaces);

  var parts = value.toString().split(".");

  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    (parts[1] ? "." + parts[1] : "")
  );
};

export const getDataTypeIcon = (dataType) => {
  if (dataType == 1)
    //bool
    return "k-i-tri-state-indeterminate";
  else if (dataType == 2)
    //number
    return "k-i-custom-format";
  else if (dataType == 3)
    //text
    return "k-i-textbox";
  else if (dataType == 4 || dataType == 5)
    //data
    return "k-i-calendar-date";

  return "";
};

export const getExpressionIcon = (isAggregate) => {
  if (isAggregate) return "k-i-sum";
  else return "k-i-formula-fx";
};

export const getDataSourceIcon = (typeId) => {
  if (typeId == 1)
    //value
    return "k-i-foreground-color";
  //table
  else return "k-i-table";
};

export const getAggregateFunctions = () => [
  { Id: 0, Title: "None" },
  { Id: 1, Title: "Count" },
  { Id: 2, Title: "Min" },
  { Id: 3, Title: "Max" },
  { Id: 4, Title: "Sum" },
  { Id: 5, Title: "Avg" },
];

export const getComparisonOperators = () => [
  { Id: 0, Title: "None" },
  { Id: 1, Title: "<" },
  { Id: 2, Title: "<=" },
  { Id: 3, Title: ">" },
  { Id: 4, Title: ">=" },
  { Id: 5, Title: "=" },
  { Id: 6, Title: "<>" },
  { Id: 7, Title: "Inclusive In" },
  { Id: 8, Title: "Exclusive In" },
];

export const getUnaryComparisonOperators = () => [
  { Id: 0, Title: "None" },
  { Id: 1, Title: "<" },
  { Id: 2, Title: "<=" },
  { Id: 3, Title: ">" },
  { Id: 4, Title: ">=" },
  { Id: 5, Title: "=" },
  { Id: 6, Title: "<>" },
];

export const comparisonOperators = [
  { Id: 0, Title: "None" },
  { Id: 1, Title: "<" },
  { Id: 2, Title: "<=" },
  { Id: 3, Title: ">" },
  { Id: 4, Title: ">=" },
  { Id: 5, Title: "=" },
  { Id: 6, Title: "<>" },
  { Id: 7, Title: "Inclusive In" },
  { Id: 8, Title: "Exclusive In" },
];

export const unaryComparisonOperators = [
  { Id: 0, Title: "None" },
  { Id: 1, Title: "<" },
  { Id: 2, Title: "<=" },
  { Id: 3, Title: ">" },
  { Id: 4, Title: ">=" },
  { Id: 5, Title: "=" },
  { Id: 6, Title: "<>" },
];

export const getComparisonOperatorsByDataType = (dataType) => {
  if (dataType == 2)
    return [
      { Id: 0, Title: "None" },
      { Id: 1, Title: "<" },
      { Id: 2, Title: "<=" },
      { Id: 3, Title: ">" },
      { Id: 4, Title: ">=" },
      { Id: 5, Title: "=" },
      { Id: 6, Title: "<>" },
      { Id: 7, Title: "Inclusive In" },
      { Id: 8, Title: "Exclusive In" },
    ];
  else if (dataType == 1) return [{ Id: 5, Title: "=" }];

  return [];
};

export const getUnaryComparisonOperatorsByDataType = (dataType) => {
  if (dataType == 2)
    return [
      { Id: 0, Title: "None" },
      { Id: 1, Title: "<" },
      { Id: 2, Title: "<=" },
      { Id: 3, Title: ">" },
      { Id: 4, Title: ">=" },
      { Id: 5, Title: "=" },
      { Id: 6, Title: "<>" },
    ];
  else if (dataType == 1) return [{ Id: 5, Title: "=" }];

  return [];
};

export const dataTypes = [
  { Id: 1, Title: "Boolean" },
  { Id: 2, Title: "Number" },
  { Id: 3, Title: "Text" },
  { Id: 4, Title: "Date" },
  { Id: 5, Title: "Date/Time" },
  { Id: 6, Title: "Guid" },
];

export const getDataType = (id) => {
  switch (id) {
    case 1:
      return "Boolean";
    case 2:
      return "Number";
    case 3:
      return "Text";
    case 4:
      return "Date";
    case 5:
      return "Date/Time";
    case 6:
      return "Guid";
  }
  return "";
};

export const getDataBaseType = (id) => {
  switch (id) {
    case 1:
      return "Azure SQL";
    case 2:
      return "SQL Server";
    case 3:
      return "MySQL";
    case 4:
      return "Oracle";
    case 5:
      return "PstogreSQL";
  }
  return "";
};

export const compare = (value1, operatorId, min, max) => {
  const operators = getComparisonOperators();

  if (
    value1 === null ||
    value1 === undefined ||
    min === null ||
    min === undefined ||
    max === null ||
    max === undefined ||
    operatorId === null ||
    operatorId === undefined
  )
    return null;

  if (
    !isNumeric(value1.toString()) ||
    !isNumeric(min.toString()) ||
    !isNumeric(max.toString()) ||
    !isNumeric(operatorId.toString()) ||
    operatorId < 1 ||
    operatorId > operators.length - 1
  )
    return null;

  if (operatorId == 1) return value1 < min;
  else if (operatorId == 2) return value1 <= min;
  else if (operatorId == 3) return value1 > min;
  else if (operatorId == 4) return value1 >= min;
  else if (operatorId == 5) return value1 == min;
  else if (operatorId == 6) return value1 != min;
  else if (operatorId == 7) return value1 >= min && value1 <= max;
  else if (operatorId == 8) return value1 > min && value1 < max;
};

export const compareUnary = (value1, operatorId, value2) => {
  const operators = getComparisonOperators();

  //console.log("CUN", value1, operatorId, value2, value1<value2)
  if (
    value1 === null ||
    value1 === undefined ||
    value2 === null ||
    value2 === undefined ||
    operatorId === null ||
    operatorId === undefined
  )
    return null;

  if (
    !isNumeric(value1.toString()) ||
    !isNumeric(value2.toString()) ||
    !isNumeric(operatorId.toString()) ||
    operatorId < 1 ||
    operatorId > operators.length - 1
  )
    return null;

  if (operatorId == 1) return parseFloat(value1) < parseFloat(value2);
  else if (operatorId == 2) return parseFloat(value1) <= parseFloat(value2);
  else if (operatorId == 3) return parseFloat(value1) > parseFloat(value2);
  else if (operatorId == 4) return parseFloat(value1) >= parseFloat(value2);
  else if (operatorId == 5) return parseFloat(value1) == parseFloat(value2);
  else if (operatorId == 6) return parseFloat(value1) != parseFloat(value2);
};

export const getAlertImportances = () => [
  { Id: 0, Title: i18next.t("datasources.none") },
  { Id: 1, Title: i18next.t("notifications.unimportant") },
  { Id: 3, Title: i18next.t("notifications.important") },
  { Id: 5, Title: i18next.t("notifications.critical") },
];

export const getAlertImportancesFilter = () => [
  { Id: 0, Title: i18next.t("extras.all") },
  { Id: 1, Title: i18next.t("notifications.unimportant") },
  { Id: 3, Title: i18next.t("notifications.important") },
  { Id: 5, Title: i18next.t("notifications.critical") },
  { Id: 35, Title: i18next.t("extras.impandcrit") },
];

export const getAlertRecurrsEveryIntervals = () => [
  { Id: 0, Title: "None" },
  // {Id: 1, Title: "1 min"},
  // {Id: 30, Title: "30 mins."},
  { Id: 60, Title: "1 hr." },
  { Id: 120, Title: "2 hrs." },
  { Id: 180, Title: "3 hrs." },
  { Id: 240, Title: "4 hrs." },
  { Id: 300, Title: "5 hrs." },
  { Id: 360, Title: "6 hrs." },
  { Id: 720, Title: "12 hrs." },
  { Id: 1440, Title: "1 day" },
  { Id: 2880, Title: "2 days" },
  { Id: 4320, Title: "3 days" },
];

export const getAlertCoveredPeriodIntervals = () => [
  { Id: 0, Title: "None" },
  // {Id: 5, Title: "5 mins."},
  // {Id: 10, Title: "10 mins."},
  // {Id: 15, Title: "15 mins."},
  { Id: 30, Title: "30 mins." },
  { Id: 60, Title: "1 hr." },
  { Id: 120, Title: "2 hrs." },
  { Id: 180, Title: "3 hrs." },
  { Id: 240, Title: "4 hrs." },
  { Id: 300, Title: "5 hrs." },
  { Id: 360, Title: "6 hrs." },
  { Id: 720, Title: "12 hrs." },
  { Id: 1440, Title: "1 day" },
  { Id: 2880, Title: "2 days" },
  { Id: 4320, Title: "3 days" },
];

export const getAlertVariantCoveredPeriodIntervals = () => [
  { Id: 0, Title: "None" },
  // {Id: 5, Title: "5 mins."},
  // {Id: 10, Title: "10 mins."},
  // {Id: 15, Title: "15 mins."},
  { Id: 30, Title: "30 mins." },
  { Id: 60, Title: "1 hr." },
  { Id: 120, Title: "2 hrs." },
  { Id: 180, Title: "3 hrs." },
  { Id: 240, Title: "4 hrs." },
  { Id: 300, Title: "5 hrs." },
  { Id: 360, Title: "6 hrs." },
  { Id: 720, Title: "12 hrs." },
  { Id: 1440, Title: "1 day" },
  { Id: 2880, Title: "2 days" },
  { Id: 4320, Title: "3 days" },
];

export const sortDirections = [
  { Id: 0, Title: "None" },
  { Id: 1, Title: "Asc" },
  { Id: -1, Title: "Desc" },
];

export const sortArrayByString = (arr, propertyName, direction = 1) => {
  if (!arr || arr.length < 1) return arr;

  if (direction == 1)
    return arr.sort((a, b) =>
      a[propertyName].toLowerCase() < b[propertyName].toLowerCase()
        ? -1
        : b[propertyName].toLowerCase() > a[propertyName].toLowerCase()
          ? 1
          : null,
    );
  else
    return arr.sort((a, b) =>
      a[propertyName].toLowerCase() < b[propertyName].toLowerCase()
        ? 1
        : b[propertyName].toLowerCase() > a[propertyName].toLowerCase()
          ? -1
          : null,
    );
};

export const isNumeric = (str) => {
  //console.log(str, str == null, str == undefined, typeof str)
  if (str == null || str == undefined || str == "") return false;

  if (typeof str != "string") return false; // we only process strings!

  str = str.toString();

  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
};

export const isInteger = (str) => {
  return isNumeric(str) && str.indexOf(".") < 0;
};

export const tryParseDate = (
  dateString,
  yearSeparator = "-",
  hourSeparator = ":",
) => {
  //accepts a date string or datetime string and returns the datetime object; ex: 0001-10-31 23:15:35'
  //when date => 00:00:00
  //returns null if invalid string

  if (!dateString) return null;

  try {
    let yearIndex = dateString.indexOf(yearSeparator);
    if (yearIndex < 1) return null;

    let year = parseInt(dateString.substr(0, yearIndex));
    if (isNaN(year) || year < 0) return null;

    let monthIndex = dateString.indexOf(yearSeparator, yearIndex + 1);
    if (monthIndex < yearIndex + 2) return null;

    let month = parseInt(
      dateString.substr(yearIndex + 1, monthIndex - yearIndex - 1),
    );
    if (isNaN(month) || month < 1 || month > 12) return null;

    let dayIndex = dateString.indexOf(" ", monthIndex + 1);
    if (dayIndex < monthIndex + 1) {
      //date only
      let day = parseInt(dateString.substr(monthIndex + 1).trim());
      if (isNaN(day) || day < 1 || day > 31) return null;
      else {
        //return datetime object with 00:00:00
        let d = new Date();

        d.setFullYear(year);
        d.setMonth(month - 1);
        d.setDate(day);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);

        return d;
      }
    }

    if (dayIndex == monthIndex + 1) return null;

    let day = parseInt(
      dateString.substr(monthIndex + 1, dayIndex - monthIndex - 1),
    );
    if (isNaN(day) || day < 1 || day > 31) return null;

    let hourIndex = dateString.indexOf(hourSeparator);
    if (hourIndex < dayIndex + 2) return null;

    let hour = parseInt(
      dateString.substr(dayIndex + 1, hourIndex - dayIndex - 1).trim(),
    );
    if (isNaN(hour) || hour < 0 || hour > 23) return null;

    let minuteIndex = dateString.indexOf(hourSeparator, hourIndex + 1);
    if (minuteIndex < hourIndex + 2) return null;

    let minute = parseInt(
      dateString.substr(hourIndex + 1, minuteIndex - hourIndex - 1),
    );
    if (isNaN(minute) || minute < 0 || minute > 59) return null;

    let second = parseInt(dateString.substr(minuteIndex + 1).trim());
    if (isNaN(second) || second < 0 || second > 59) return null;

    let d = new Date();

    d.setFullYear(year);
    d.setMonth(month - 1);
    d.setDate(day);
    d.setHours(hour);
    d.setMinutes(minute);
    d.setSeconds(second);

    return d;
  } catch (ex) {
    return null;
  }
};

export const dateTimeToString = (d) => {
  let year = d.getFullYear().toString();

  let month = (d.getMonth() + 1).toString();
  let day = d.getDate().toString();

  let hour = d.getHours().toString();
  let minute = d.getMinutes().toString();
  let second = d.getSeconds().toString();

  if (year.length == 1) year = "000" + year;
  else if (year.length == 2) year = "00" + year;
  else if (year.length == 3) year = "0" + year;

  if (month.length == 1) month = "0" + month;

  if (day.length == 1) day = "0" + day;

  if (hour.length == 1) hour = "0" + hour;

  if (minute.length == 1) minute = "0" + minute;

  if (second.length == 1) second = "0" + second;

  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};

export const formatDateTime = (d, includeSeconds = true) => {
  d = new Date(d);

  let year = d.getFullYear().toString();
  let month = (d.getMonth() + 1).toString();
  let day = d.getDate().toString();

  let hour = d.getHours().toString();
  let minute = d.getMinutes().toString();
  let second = d.getSeconds().toString();

  if (year.length == 1) year = "000" + year;
  else if (year.length == 2) year = "00" + year;
  else if (year.length == 3) year = "0" + year;

  if (month.length == 1) month = "0" + month;

  if (day.length == 1) day = "0" + day;

  if (hour.length == 1) hour = "0" + hour;

  if (minute.length == 1) minute = "0" + minute;

  if (second.length == 1) second = "0" + second;

  if (includeSeconds)
    return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
  else return `${day}-${month}-${year} ${hour}:${minute}`;
};

export const formatNumber = (value, decimalPlaces, thousandSeparator = ",") => {
  if (isNaN(parseFloat(value))) return "";

  if (decimalPlaces < 0) decimalPlaces = 0;

  let isDecimal = value.toString().indexOf(".") >= 0;

  if (isDecimal) value = value.toFixed(decimalPlaces);

  if (!thousandSeparator || thousandSeparator.trim() == "")
    return value.toString();

  thousandSeparator = thousandSeparator.substring(0, 1);

  var parts = value.toString().split(".");

  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator) +
    (parts[1] ? "." + parts[1] : "")
  );
};

export const convertNumber = (value, decimalPlaces = 2) => {
  //returns a number not a string if value is numeric
  if (
    value == null ||
    value == undefined ||
    decimalPlaces == null ||
    decimalPlaces == undefined
  )
    return null;

  let _value = value.toString();
  let _decimalPlaces = decimalPlaces.toString();

  if (!isNumeric(_value) || !isNumeric(_decimalPlaces) || decimalPlaces < 0)
    return null;
  return parseFloat(parseFloat(value).toFixed(decimalPlaces));
};

export const toCamel = (o) => {
  var newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === "object") {
        value = toCamel(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (
          origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey
        ).toString();
        value = o[origKey];
        if (
          value instanceof Array ||
          (value !== null && value.constructor === Object)
        ) {
          value = toCamel(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
};

export const dateFormats = [
  { id: 1, title: "dd-mm-yyyy" },
  { id: 2, title: "dd-mm-yyyy HH:MM" },
  { id: 3, title: "dd-mmm-yyyy" },
  { id: 4, title: "dd-mmm-yyyy HH:MM" },
  { id: 5, title: "mm-dd-yyyy" },
  { id: 6, title: "mm-dd-yyyy HH:MM" },
  { id: 7, title: "mmm-dd-yyyy" },
  { id: 8, title: "mmm-dd-yyyy HH:MM" },
  { id: 9, title: "yyyy-mm-dd" },
  { id: 10, title: "yyyy-mm-dd HH:MM" },
  { id: 11, title: "yyyy-mmm-dd" },
  { id: 12, title: "yyyy-mmm-dd HH:MM" },
];

export const formatDate = (date, format) => {
  if (!date || isEmptyObject(date)) return null;

  return dateFormat(date, format);
};

export const notificationDurationShort = 3;
export const notificationDurationMiddle = 6;
export const notificationDurationLong = 10;

export const getPathObject = (pathName) => ({
  pathname: pathName,
  key: new Date().toString(),
});

export const getExpressionBodyTokens = (expression) => {
  let result = { status: false, tokens: [] };

  let tokens = [];

  if (!expression || expression.trim() == "") return result;

  let title = "";
  let i = 0,
    j = 0;

  i = expression.indexOf("[", 0);
  j = expression.indexOf("]", 0);
  if (i < 0 && j < 0) return result;

  if (i < 0 || j < 0 || j < i) return result;

  while (i >= 0) {
    j = expression.indexOf("]", i + 1);
    if (j == i + 1) return result;

    title = expression.substr(i + 1, j - i - 1);
    if (!title || title.trim() == "") return result;

    if (!tokens.find((e) => e == title)) tokens.push(title);

    i = expression.indexOf("[", j + 1);
  }

  result.status = true;
  result.tokens = tokens;

  return result;
};

export const getThemeColors = (currentTheme) => {
  return [
    { id: 1, title: "Background", color: currentTheme.componentBg },
    { id: 2, title: "Border", color: currentTheme.componentBorderColor },
    { id: 3, title: "Error", color: currentTheme.error },
    { id: 4, title: "Info", color: currentTheme.info },
    { id: 5, title: "Primary", color: currentTheme.primary },
    { id: 6, title: "Secondary", color: currentTheme.secondary },
    { id: 7, title: "Separator", color: currentTheme.separatorColor },
    { id: 8, title: "Success", color: currentTheme.success },
    { id: 9, title: "Text", color: currentTheme.componentText },
    { id: 10, title: "Warning", color: currentTheme.warning },

    { id: 11, title: "Black", color: currentTheme.black },
    { id: 12, title: "Blue", color: currentTheme.blue },
    { id: 13, title: "Green", color: currentTheme.green },
    { id: 14, title: "Orange", color: currentTheme.orange },
    { id: 15, title: "Pink", color: currentTheme.pink },
    { id: 16, title: "Purple", color: currentTheme.purple },
    { id: 17, title: "Red", color: currentTheme.red },
    { id: 18, title: "Yellow", color: currentTheme.yellow },
    { id: 19, title: "White", color: currentTheme.white },
  ];
};

export const getLastDayOfMonth = (date) => {
  var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return lastDayOfMonth.getDate();
};

export const nonRangeDateTimeKeys = [
  { Id: "nowNonRange", Title: "Now" },
  { Id: "todayStart", Title: "Today Start" },
  { Id: "todayEnd", Title: "Today End" },
  { Id: "yesterdayStart", Title: "Yesterday Start" },
  { Id: "yesterdayEnd", Title: "Yesterday End" },
  { Id: "dayBeforeStart", Title: "Day Before Start" },
  { Id: "dayBeforeEnd", Title: "Day Before End" },
  { Id: "currentWeekStart", Title: "Cur. Week Start" },
  { Id: "currentWeekEnd", Title: "Cur. Week End" },
  { Id: "previousWeekStart", Title: "Prev. Week Start" },
  { Id: "previousWeekEnd", Title: "Prev. Week End" },
  { Id: "currentMonthStart", Title: "Cur. Month Start" },
  { Id: "currentMonthEnd", Title: "Cur. Month End" },
  { Id: "previousMonthStart", Title: "Prev. Month Start" },
  { Id: "previousMonthEnd", Title: "Prev. Month End" },
  { Id: "currentQuarterStart", Title: "Cur. Quarter Start" },
  { Id: "currentQuarterEnd", Title: "Cur. Quarter End" },
  { Id: "previousQuarterStart", Title: "Prev. Quarter Start" },
  { Id: "previousQuarterEnd", Title: "Prev. Quarter End" },
  { Id: "currentYearStart", Title: "Cur. Year Start" },
  { Id: "currentYearEnd", Title: "Cur. Year End" },
  { Id: "previousYearStart", Title: "Prev. Year Start" },
  { Id: "previousYearEnd", Title: "Prev. Year End" },
  { Id: "dummy1", Title: "" },
];

export const rangeDateTimeKeys = [
  { Id: "todayRange", Title: "Today" },
  { Id: "yesterdayRange", Title: "Yesterday" },
  { Id: "dayBeforeRange", Title: "Day Before" },
  { Id: "yesterdayAndToday", Title: "Yest. & Today" },
  { Id: "dayBeforeToToday", Title: "Day Bef. to Today" },
  { Id: "currentWeek", Title: "Current Week" },
  { Id: "previousWeek", Title: "Previous Week" },
  { Id: "currentMonth", Title: "Cur. Month" },
  { Id: "previousMonth", Title: "Prev. Month" },
  { Id: "currentYear", Title: "Cur. Year" },
  { Id: "previousYear", Title: "Prev. Year" },
  { Id: "24Back", Title: "24 hrs Back" },
  { Id: "48Back", Title: "48 hrs Back" },
  { Id: "72Back", Title: "72 hrs Back" },
  { Id: "weekBackDateTime", Title: "A Week Back" },
  { Id: "twoWeeksBackDateTime", Title: "2 Weeks Back" },
  { Id: "threeWeeksBackDateTime", Title: "3 Weeks Back" },
  { Id: "monthBackDateTime", Title: "A Month Back" },
  { Id: "twoMonthsBackDateTime", Title: "2 Months Back" },
  { Id: "threeMonthsBackDateTime", Title: "3 Months Back" },
  { Id: "yearBackDateTime", Title: "A Year Back" },
  { Id: "dummy2", Title: "" },
  { Id: "dummy3", Title: "" },
  { Id: "dummy4", Title: "" },
];

export const nonRangeDateKeys = [
  { Id: "today", Title: "Today" },
  { Id: "yesterdayNonRange", Title: "Yesterday" },
  { Id: "dayBeforeNonRange", Title: "Day Before" },
  { Id: "currentWeekStart", Title: "Cur. Week Start" },
  { Id: "currentWeekEnd", Title: "Cur. Week End" },
  { Id: "previousWeekStart", Title: "Prev. Week Start" },
  { Id: "previousWeekEnd", Title: "Prev. Week End" },
  { Id: "currentMonthStart", Title: "Cur. Month Start" },
  { Id: "currentMonthEnd", Title: "Cur. Month End" },
  { Id: "previousMonthStart", Title: "Prev. Month Start" },
  { Id: "previousMonthEnd", Title: "Prev. Month End" },
  { Id: "currentQuarterStart", Title: "Cur. Quarter Start" },
  { Id: "currentQuarterEnd", Title: "Cur. Quarter End" },
  { Id: "previousQuarterStart", Title: "Prev. Quarter Start" },
  { Id: "previousQuarterEnd", Title: "Prev. Quarter End" },
  { Id: "currentYearStart", Title: "Cur. Year Start" },
  { Id: "currentYearEnd", Title: "Cur. Year End" },
  { Id: "previousYearStart", Title: "Prev. Year Start" },
  { Id: "previousYearEnd", Title: "Prev. Year End" },
  { Id: "dummy1", Title: "" },
];

export const rangeDateKeys = [
  //{Id: "yesterdayToNow", Title: "Yest. to Now"},  {Id: "dayBeforeToNow", Title: "Day Bef. to Now"},
  { Id: "yesterdayAndToday", Title: "Yest. & Today" },
  { Id: "dayBeforeToToday", Title: "Day Bef. to Today" },
  { Id: "currentWeek", Title: "Current Week" },
  { Id: "previousWeek", Title: "Previous Week" },
  { Id: "currentMonth", Title: "Cur. Month" },
  { Id: "previousMonth", Title: "Prev. Month" },
  { Id: "currentYear", Title: "Cur. Year" },
  { Id: "previousYear", Title: "Prev. Year" },
  { Id: "weekBackDate", Title: "A Week Back" },
  { Id: "twoWeeksBackDate", Title: "2 Weeks Back" },
  { Id: "threeWeeksBackDate", Title: "3 Weeks Back" },
  { Id: "monthBackDate", Title: "A Month Back" },
  { Id: "twoMonthsBackDate", Title: "2 Months Back" },
  { Id: "threeMonthsBackDate", Title: "3 Months Back" },
  { Id: "yearBackDate", Title: "A Year Back" },
  { Id: "dummy2", Title: "" },
];

export const dateOnlyString = (d) => {
  //from a Date, returns a string representing the date in the yyy-MM-dd 00:00:00 format
  let year = d.getFullYear().toString();
  let month = (d.getMonth() + 1).toString();
  let day = d.getDate().toString();

  if (year.length == 1) year = "000" + year;
  else if (year.length == 2) year = "00" + year;
  else if (year.length == 3) year = "0" + year;

  if (month.length == 1) month = "0" + month;

  if (day.length == 1) day = "0" + day;

  return `${year}-${month}-${day}`;
};

export const dateTimeString = (d) => {
  //from a Date parameter, returns the string in the format yyyy-MM-dd HH:mm:ss
  return dateTimeToString(d);
};

export const getJsonDateStringFromDateKey = (key) => {
  let date = new Date();
  if (key && key.trim() != "") {
    key = key.trim().toLowerCase();

    if (key == "nownonrange") return toLocalISOString(new Date());
    else if (key == "todaystart") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0,
        0,
        0,
      );
      return toLocalISOString(result);
    } else if (key == "todayend") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
      );
      return toLocalISOString(result);
    } else if (key == "yesterdaystart") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        0,
        0,
        0,
        0,
      );
      return toLocalISOString(result);
    } else if (key == "yesterdayend") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        23,
        59,
        59,
      );
      return toLocalISOString(result);
    } else if (key == "daybeforestart") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        0,
        0,
        0,
        0,
      );
      return toLocalISOString(result);
    } else if (key == "daybeforeend") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        23,
        59,
        59,
      );
      return toLocalISOString(result);
    } else if (key == "currentweekstart") {
      var first = date.getDate() - ((date.getDay() + 6) % 7); // date.getDate() - date.getDay() + 1;
      var firstDay = new Date(date.setDate(first));

      firstDay.setHours(0);
      firstDay.setMinutes(0);
      firstDay.setSeconds(0);

      return toLocalISOString(firstDay);
    } else if (key == "currentweekend") {
      var first = date.getDate() - ((date.getDay() + 6) % 7); //date.getDate() - date.getDay() + 1;
      var last = first + 6; // last day is the first day + 6
      var lastDay = new Date(date.setDate(last));

      lastDay.setHours(23);
      lastDay.setMinutes(59);
      lastDay.setSeconds(59);

      return toLocalISOString(lastDay);
    } else if (key == "previousweekstart") {
      var first = date.getDate() - 7 - ((date.getDay() + 6) % 7); // date.getDate() - date.getDay() + 1;
      var firstDay = new Date(date.setDate(first));

      firstDay.setHours(0);
      firstDay.setMinutes(0);
      firstDay.setSeconds(0);

      return toLocalISOString(firstDay);
    } else if (key == "previousweekend") {
      var first = date.getDate() - 7 - ((date.getDay() + 6) % 7); //date.getDate() - date.getDay() + 1;
      var last = first + 6; // last day is the first day + 6
      var lastDay = new Date(date.setDate(last));

      lastDay.setHours(23);
      lastDay.setMinutes(59);
      lastDay.setSeconds(59);

      return toLocalISOString(lastDay);
    } else if (key == "currentmonthstart") {
      let result = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
      return toLocalISOString(result);
    } else if (key == "currentmonthend") {
      let result;

      result = new Date(
        date.getFullYear(),
        date.getMonth(),
        getLastDayOfMonth(date),
        23,
        59,
        59,
      );

      return toLocalISOString(result);
    } else if (key == "previousmonthstart") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        1,
        0,
        0,
        0,
        0,
      );
      return toLocalISOString(result);
    } else if (key == "previousmonthend") {
      let result;

      let temp = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        1,
        0,
        0,
        0,
        0,
      );

      result = new Date(
        temp.getFullYear(),
        temp.getMonth(),
        getLastDayOfMonth(temp),
        23,
        59,
        59,
      );

      return toLocalISOString(result);
    } else if (key == "currentquarterstart") {
      let currentMonth = date.getMonth();
      let startMonth =
        currentMonth < 3 ? 0 : currentMonth < 6 ? 3 : currentMonth < 9 ? 6 : 9;
      let result = new Date(date.getFullYear(), startMonth, 1, 0, 0, 0, 0);
      return toLocalISOString(result);
    } else if (key == "currentquarterend") {
      let currentMonth = date.getMonth();
      let endMonth =
        currentMonth < 3 ? 2 : currentMonth < 6 ? 5 : currentMonth < 9 ? 8 : 11;
      let endDay = endMonth == 5 || endMonth == 8 ? 30 : 31;

      let result;

      result = new Date(date.getFullYear(), endMonth, endDay, 23, 59, 59);

      return toLocalISOString(result);
    } else if (key == "previousquarterstart") {
      let currentMonth = date.getMonth();
      let startMonth =
        currentMonth < 3 ? 9 : currentMonth < 6 ? 0 : currentMonth < 9 ? 3 : 6;
      let result = new Date(date.getFullYear(), startMonth, 1, 0, 0, 0, 0);

      return toLocalISOString(result);
    } else if (key == "previousquarterend") {
      let currentMonth = date.getMonth();
      let endMonth =
        currentMonth < 3 ? 11 : currentMonth < 6 ? 2 : currentMonth < 9 ? 5 : 8;
      let endDay = endMonth == 5 || endMonth == 8 ? 30 : 31;

      let result;

      result = new Date(date.getFullYear(), endMonth, endDay, 23, 59, 59);

      return toLocalISOString(result);
    } else if (key == "currentyearstart") {
      let result = new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);

      return toLocalISOString(result);
    } else if (key == "currentyearend") {
      let result;

      result = new Date(date.getFullYear(), 11, 31, 23, 59, 59);

      return toLocalISOString(result);
    } else if (key == "previousyearstart") {
      let result = new Date(date.getFullYear() - 1, 0, 1, 0, 0, 0, 0);

      return toLocalISOString(result);
    } else if (key == "previousyearend") {
      let result = new Date(date.getFullYear() - 1, 11, 31, 23, 59, 59);

      return toLocalISOString(result);
    }
    // else if (key == "nowrange")
    // {
    //     let start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    //     let end = new Date();
    //     return [start.toJSON(), end.toJSON()];
    // }
    else if (key == "todayrange") {
      let sDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0,
        0,
        0,
      );
      let eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
      );
      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "yesterdayrange") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        0,
        0,
        0,
        0,
      );
      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        23,
        59,
        59,
      );
      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "daybeforerange") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        0,
        0,
        0,
        0,
      );
      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        23,
        59,
        59,
      );
      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    }
    // else if (key == "yesterdaytonow")
    // {
    //     var sDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() -1, 0, 0, 0, 0);
    //     var eDate = new Date();
    //     return [sDate.toJSON(), eDate.toJSON()];
    // }
    else if (key == "yesterdayandtoday") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        0,
        0,
        0,
        0,
      );
      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
      );

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    }
    // else if (key == "daybeforetonow")
    // {
    //     var sDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() -2, 0, 0, 0, 0);
    //     var eDate = new Date();
    //     return [sDate.toJSON(), eDate.toJSON()];
    // }
    else if (key == "daybeforetotoday") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        0,
        0,
        0,
        0,
      );
      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
      );
      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "currentweek") {
      var first = date.getDate() - ((date.getDay() + 6) % 7);

      var sDate = new Date(date.setDate(first));

      sDate.setHours(0);
      sDate.setMinutes(0);
      sDate.setSeconds(0);

      var last = first + 6; // last day is the first day + 6

      var eDate = new Date(date.setDate(last));

      eDate.setHours(23);
      eDate.setMinutes(59);
      eDate.setSeconds(59);

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "previousweek") {
      const today = new Date();
      // Find the Monday of the *previous* week
      const dayOfWeek = (today.getDay() + 6) % 7; // 0 = Monday, 6 = Sunday
      const startOfPrevWeek = new Date(today);
      startOfPrevWeek.setDate(today.getDate() - dayOfWeek - 7);
      startOfPrevWeek.setHours(0, 0, 0, 0);

      // End of previous week (Sunday)
      const endOfPrevWeek = new Date(startOfPrevWeek);
      endOfPrevWeek.setDate(startOfPrevWeek.getDate() + 6);
      endOfPrevWeek.setHours(23, 59, 59, 999);

      return [
        toLocalISOString(startOfPrevWeek),
        toLocalISOString(endOfPrevWeek),
      ];
    } else if (key == "currentmonth") {
      var sDate = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);

      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        getLastDayOfMonth(date),
        23,
        59,
        59,
      );

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "previousmonth") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        1,
        0,
        0,
        0,
        0,
      );

      let temp = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        1,
        0,
        0,
        0,
        0,
      );

      let eDate = new Date(
        temp.getFullYear(),
        temp.getMonth(),
        getLastDayOfMonth(temp),
        23,
        59,
        59,
      );

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "currentyear") {
      var sDate = new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);

      var eDate = new Date(date.getFullYear(), 11, 31, 23, 59, 59);

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "previousyear") {
      var sDate = new Date(date.getFullYear() - 1, 0, 1, 0, 0, 0, 0);

      var eDate = new Date(date.getFullYear() - 1, 11, 31, 23, 59, 59);

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "24back") {
      var sDate = new Date(new Date().getTime() - 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "48back") {
      var sDate = new Date(new Date().getTime() - 48 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "72back") {
      var sDate = new Date(new Date().getTime() - 72 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "weekbackdatetime") {
      var sDate = new Date(new Date().getTime() - 7 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "twoweeksbackdatetime") {
      var sDate = new Date(new Date().getTime() - 14 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "threeweeksbackdatetime") {
      var sDate = new Date(new Date().getTime() - 21 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "monthbackdatetime") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 1);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "twomonthsbackdatetime") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 2);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "threemonthsbackdatetime") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 3);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "yearbackdatetime") {
      var sDate = new Date();
      sDate.setFullYear(sDate.getFullYear() - 1);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "today") return toLocalISOString(new Date());
    else if (key == "yesterdaynonrange") {
      var d = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        0,
        0,
        0,
        0,
      );
      return toLocalISOString(d);
    } else if (key == "daybeforenonrange") {
      var d = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        0,
        0,
        0,
        0,
      );
      return toLocalISOString(d);
    } else if (key == "weekbackdate") {
      var sDate = new Date(new Date().getTime() - 6 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "twoweeksbackdate") {
      var sDate = new Date(new Date().getTime() - 13 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "threeweeksbackdate") {
      var sDate = new Date(new Date().getTime() - 20 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "monthbackdate") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 1);

      sDate = new Date(sDate.getTime() + 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "twomonthsbackdate") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 2);

      sDate = new Date(sDate.getTime() + 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "threemonthsbackdate") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 3);

      sDate = new Date(sDate.getTime() + 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    } else if (key == "yearbackdate") {
      var sDate = new Date();
      sDate.setFullYear(sDate.getFullYear() - 1);

      sDate = new Date(sDate.getTime() + 24 * 3600 * 1000);

      var eDate = new Date();

      return [toLocalISOString(sDate), toLocalISOString(eDate)];
    }
  }

  return null;
};

export const getDateFromDateKey = (key) => {
  let date = new Date();

  if (key && key.trim() != "") {
    key = key.trim().toLowerCase();

    if (key == "nownonrange") return new Date();
    else if (key == "todaystart")
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0,
        0,
        0,
      );
    else if (key == "todayend")
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
      );
    else if (key == "yesterdaystart")
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        0,
        0,
        0,
        0,
      );
    else if (key == "yesterdayend")
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        23,
        59,
        59,
      );
    else if (key == "daybeforestart") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        0,
        0,
        0,
        0,
      );
      return result;
    } else if (key == "daybeforeend") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        23,
        59,
        59,
      );
      return result;
    } else if (key == "currentweekstart") {
      var first = date.getDate() - ((date.getDay() + 6) % 7); // date.getDate() - date.getDay() + 1;
      var firstDay = new Date(date.setDate(first));

      firstDay.setHours(0);
      firstDay.setMinutes(0);
      firstDay.setSeconds(0);

      return firstDay;
    } else if (key == "currentweekend") {
      var first = date.getDate() - ((date.getDay() + 6) % 7); //date.getDate() - date.getDay() + 1;
      var last = first + 6; // last day is the first day + 6
      var lastDay = new Date(date.setDate(last));

      lastDay.setHours(23);
      lastDay.setMinutes(59);
      lastDay.setSeconds(59);

      return lastDay;
    } else if (key == "previousweekstart") {
      var first = date.getDate() - 7 - ((date.getDay() + 6) % 7); // date.getDate() - date.getDay() + 1;
      var firstDay = new Date(date.setDate(first));

      firstDay.setHours(0);
      firstDay.setMinutes(0);
      firstDay.setSeconds(0);

      return firstDay;
    } else if (key == "previousweekend") {
      var first = date.getDate() - 7 - ((date.getDay() + 6) % 7); //date.getDate() - date.getDay() + 1;
      var last = first + 6; // last day is the first day + 6
      var lastDay = new Date(date.setDate(last));

      lastDay.setHours(23);
      lastDay.setMinutes(59);
      lastDay.setSeconds(59);

      return lastDay;
    } else if (key == "currentmonthstart") {
      let result = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
      return result;
    } else if (key == "currentmonthend") {
      let result;

      result = new Date(
        date.getFullYear(),
        date.getMonth(),
        getLastDayOfMonth(date),
        23,
        59,
        59,
      );

      return result;
    } else if (key == "previousmonthstart") {
      let result = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        1,
        0,
        0,
        0,
        0,
      );
      return result;
    } else if (key == "previousmonthend") {
      let result;

      let temp = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        1,
        0,
        0,
        0,
        0,
      );

      result = new Date(
        temp.getFullYear(),
        temp.getMonth(),
        getLastDayOfMonth(temp),
        23,
        59,
        59,
      );

      return result;
    } else if (key == "currentquarterstart") {
      let currentMonth = date.getMonth();
      let startMonth =
        currentMonth < 3 ? 0 : currentMonth < 6 ? 3 : currentMonth < 9 ? 6 : 9;
      let result = new Date(date.getFullYear(), startMonth, 1, 0, 0, 0, 0);
      return result;
    } else if (key == "currentquarterend") {
      let currentMonth = date.getMonth();
      let endMonth =
        currentMonth < 3 ? 2 : currentMonth < 6 ? 5 : currentMonth < 9 ? 8 : 11;
      let endDay = endMonth == 5 || endMonth == 8 ? 30 : 31;

      let result;

      result = new Date(date.getFullYear(), endMonth, endDay, 23, 59, 59);

      return result;
    } else if (key == "previousquarterstart") {
      let currentMonth = date.getMonth();
      let startMonth =
        currentMonth < 3 ? 9 : currentMonth < 6 ? 0 : currentMonth < 9 ? 3 : 6;
      let result = new Date(date.getFullYear(), startMonth, 1, 0, 0, 0, 0);
      return result;
    } else if (key == "previousquarterend") {
      let currentMonth = date.getMonth();
      let endMonth =
        currentMonth < 3 ? 11 : currentMonth < 6 ? 2 : currentMonth < 9 ? 5 : 8;
      let endDay = endMonth == 5 || endMonth == 8 ? 30 : 31;

      let result;

      result = new Date(date.getFullYear(), endMonth, endDay, 23, 59, 59);

      return result;
    } else if (key == "currentyearstart") {
      let result = new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);
      return result;
    } else if (key == "currentyearend") {
      let result;

      result = new Date(date.getFullYear(), 11, 31, 23, 59, 59);

      return result;
    } else if (key == "previousyearstart") {
      let result = new Date(date.getFullYear() - 1, 0, 1, 0, 0, 0, 0);
      return result;
    } else if (key == "previousyearend") {
      let result = new Date(date.getFullYear() - 1, 11, 31, 23, 59, 59);

      return result;
    }
    // else if (key == "nowrange")
    // {
    //     let start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    //     let end = new Date();
    //     return [start, end];
    // }
    else if (key == "todayrange") {
      let start = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0,
        0,
        0,
      );
      let end = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
      );
      return [start, end];
    } else if (key == "yesterdayrange") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        0,
        0,
        0,
        0,
      );
      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        23,
        59,
        59,
      );
      return [sDate, eDate];
    } else if (key == "daybeforerange") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        0,
        0,
        0,
        0,
      );
      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        23,
        59,
        59,
      );
      return [sDate, eDate];
    }
    // else if (key == "yesterdaytonow")
    // {
    //     var sDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() -1, 0, 0, 0, 0);
    //     var eDate = new Date();
    //     return [sDate, eDate];
    // }
    else if (key == "yesterdayandtoday") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        0,
        0,
        0,
        0,
      );
      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
      );

      return [sDate, eDate];
    }
    // else if (key == "daybeforetonow")
    // {
    //     var sDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() -2, 0, 0, 0, 0);
    //     var eDate = new Date();
    //     return [sDate, eDate];
    // }
    else if (key == "daybeforetotoday") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        0,
        0,
        0,
        0,
      );
      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
      );
      return [sDate, eDate];
    } else if (key == "currentweek") {
      var first = date.getDate() - ((date.getDay() + 6) % 7);

      var sDate = new Date(date.setDate(first));

      sDate.setHours(0);
      sDate.setMinutes(0);
      sDate.setSeconds(0);

      var last = first + 6; // last day is the first day + 6

      var eDate = new Date(date.setDate(last));

      eDate.setHours(23);
      eDate.setMinutes(59);
      eDate.setSeconds(59);

      return [sDate, eDate];
    } else if (key == "previousweek") {
      const today = new Date(date); // clone to avoid mutation
      const dayOfWeek = (today.getDay() + 6) % 7; // Monday = 0, Sunday = 6

      // Calculate start of previous week (Monday)
      const first = today.getDate() - dayOfWeek - 7;
      const sDate = new Date(today);
      sDate.setDate(first);
      sDate.setHours(0, 0, 0, 0);

      // Calculate end of previous week (Sunday)
      const eDate = new Date(sDate);
      eDate.setDate(sDate.getDate() + 6);
      eDate.setHours(23, 59, 59, 999);

      return [sDate, eDate];
    } else if (key == "currentmonth") {
      var sDate = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);

      var eDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        getLastDayOfMonth(date),
        23,
        59,
        59,
      );

      return [sDate, eDate];
    } else if (key == "previousmonth") {
      var sDate = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        1,
        0,
        0,
        0,
        0,
      );

      let temp = new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        1,
        0,
        0,
        0,
        0,
      );

      let eDate = new Date(
        temp.getFullYear(),
        temp.getMonth(),
        getLastDayOfMonth(temp),
        23,
        59,
        59,
      );

      return [sDate, eDate];
    } else if (key == "currentyear") {
      var sDate = new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);

      var eDate = new Date(date.getFullYear(), 11, 31, 23, 59, 59);

      return [sDate, eDate];
    } else if (key == "previousyear") {
      var sDate = new Date(date.getFullYear() - 1, 0, 1, 0, 0, 0, 0);

      var eDate = new Date(date.getFullYear() - 1, 11, 31, 23, 59, 59);

      return [sDate, eDate];
    } else if (key == "24back") {
      var sDate = new Date(new Date().getTime() - 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "48back") {
      var sDate = new Date(new Date().getTime() - 48 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "72back") {
      var sDate = new Date(new Date().getTime() - 72 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "weekbackdatetime") {
      var sDate = new Date(new Date().getTime() - 7 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "twoweeksbackdatetime") {
      var sDate = new Date(new Date().getTime() - 14 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "threeweeksbackdatetime") {
      var sDate = new Date(new Date().getTime() - 21 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "monthbackdatetime") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 1);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "twomonthsbackdatetime") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 2);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "threemonthsbackdatetime") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 3);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "yearbackdatetime") {
      var sDate = new Date();
      sDate.setFullYear(sDate.getFullYear() - 1);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "today") return new Date();
    else if (key == "yesterdaynonrange") {
      var d = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 1,
        0,
        0,
        0,
        0,
      );
      return d;
    } else if (key == "daybeforenonrange") {
      var d = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 2,
        0,
        0,
        0,
        0,
      );
      return d;
    } else if (key == "weekbackdate") {
      var sDate = new Date(new Date().getTime() - 6 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "twoweeksbackdate") {
      var sDate = new Date(new Date().getTime() - 13 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "threeweeksbackdate") {
      var sDate = new Date(new Date().getTime() - 20 * 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "monthbackdate") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 1);

      sDate = new Date(sDate.getTime() + 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "twomonthsbackdate") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 2);

      sDate = new Date(sDate.getTime() + 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "threemonthsbackdate") {
      var sDate = new Date();
      sDate.setMonth(sDate.getMonth() - 3);

      sDate = new Date(sDate.getTime() + 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    } else if (key == "yearbackdate") {
      var sDate = new Date();
      sDate.setFullYear(sDate.getFullYear() - 1);

      sDate = new Date(sDate.getTime() + 24 * 3600 * 1000);

      var eDate = new Date();

      return [sDate, eDate];
    }
  }

  return null;
};

//used in Report Designer Groups Icons
export const iconsData = [
  { Id: 0, Title: "None", Icon: "" },
  { Id: 1, Title: "Bell", Icon: "k-i-bell" },
  { Id: 2, Title: "Calculator", Icon: "k-i-calculator" },
  { Id: 3, Title: "Calendar", Icon: "k-i-calendar" },
  { Id: 4, Title: "Cart", Icon: "k-i-cart" },
  { Id: 5, Title: "Clip", Icon: "k-i-clip" },
  { Id: 6, Title: "Clock", Icon: "k-i-clock" },
  { Id: 7, Title: "Connector", Icon: "k-i-connector" },
  { Id: 8, Title: "Delete", Icon: "k-i-delete" },
  { Id: 9, Title: "Dollar", Icon: "k-i-dollar" },
  { Id: 10, Title: "Error", Icon: "k-i-error" },
  { Id: 11, Title: "Exe", Icon: "k-i-exe" },
  { Id: 12, Title: "Eye", Icon: "k-i-eye" },
  { Id: 13, Title: "Folder", Icon: "k-i-folder" },
  { Id: 14, Title: "Folder More", Icon: "k-i-folder-more" },
  { Id: 15, Title: "Formula", Icon: "k-i-formula-fx" },
  { Id: 16, Title: "Group", Icon: "k-i-group" },
  { Id: 17, Title: "Help", Icon: "k-i-help" },
  { Id: 18, Title: "Hyperlink", Icon: "k-i-hyperlink" },
  { Id: 19, Title: "Info", Icon: "k-i-info" },
  { Id: 20, Title: "Gear", Icon: "k-i-gear" },
  { Id: 21, Title: "Grid", Icon: "k-i-grid" },
  { Id: 22, Title: "Lock", Icon: "k-i-lock" },
  { Id: 23, Title: "Minus", Icon: "k-i-minus" },
  { Id: 24, Title: "Paste", Icon: "k-i-paste" },
  { Id: 25, Title: "Pin", Icon: "k-i-pin" },
  { Id: 26, Title: "Plus", Icon: "k-i-plus" },
  { Id: 27, Title: "Properties", Icon: "k-i-table-properties" },
  { Id: 28, Title: "Settings", Icon: "k-i-settings" },
  { Id: 29, Title: "Sum", Icon: "k-i-sum" },
  { Id: 30, Title: "Table", Icon: "k-i-table" },
  { Id: 31, Title: "Tools", Icon: "k-i-edit-tools" },
  { Id: 32, Title: "Unlock", Icon: "k-i-unlock" },
  { Id: 33, Title: "Unpin", Icon: "k-i-unpin" },
  { Id: 34, Title: "Wrench", Icon: "k-i-wrench" },
  { Id: 35, Title: "Zoom", Icon: "k-i-zoom" },
  { Id: 36, Title: "Zoom In", Icon: "k-i-zoom-in" },
  { Id: 37, Title: "Zoom Out", Icon: "k-i-zoom-out" },
];

export const flattenReportsMenu = (groups) => {
  let result = [];

  for (let g in groups) {
    let group = groups[g];

    result.push({
      id: group.Id,
      text: group.Title,
      icon: group.Icon,
      ["data-expanded"]: false,
    });

    if (group.Items && group.Items.length > 0) {
      for (let i in group.Items) {
        let item = group.Items[i];
        result.push({
          id: item.Id,
          text: item.Title,
          parentId: group.Id,
          referenceKey: item.ReferenceKey,
        });
      }
    }

    if (g < groups.length - 1) result.push({ separator: true });
  }

  return result;
};

export const transformReportsMenu = (entries) => {
  if (!entries || entries.length < 1) return entries;

  let result = [];

  for (let ent in entries) {
    let entry = entries[ent];

    let obj = { id: entry.Id, text: entry.Title, icon: entry.Icon };

    if (entry.IsGroup) {
      obj["data-expanded"] = false;
    } else {
      obj.parentId = entry.ParentId;
      obj.referenceKey = entry.ReferenceKey;
    }

    result.push(obj);

    if (entry.IsGroup) result.push({ separator: true });
  }

  //console.log("Transform ", result)
  return result;
};

export function isValidEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

export function isValidDatasetName(title) {
  const regex = /^[a-zA-Z0-9_]+$/;
  return regex.test(title);
}

export function isValidDatasetTitle(title) {
  const regex = /^[a-zA-Z0-9_ ]+$/;
  return regex.test(title);
}

export function isValidDatasetFieldTitle(title) {
  const regex = /^[a-zA-Z0-9 ]+$/;
  return regex.test(title);
}

export function isNullOrEmpty(str) {
  return str === null || str === undefined || str.trim() === "";
}

export const periodFromNumber = [
  { number: 1, period: "Day" },
  { number: 2, period: "Week" },
  { number: 3, period: "Month" },
  { number: 4, period: "Year" },
];

export const toLocalISOString = (date) => {
  if (!(date instanceof Date)) return "";

  const pad = (n) => String(n).padStart(2, "0");

  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    " " +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
};

export const updateRuleAtPath = (query, path, keyId, rangeIndex = 0) => {
  const dateValue = getJsonDateStringFromDateKey(keyId);

  const updateRecursive = (rules, depth = 0) => {
    return rules.map((rule, index) => {
      if (index !== path[depth]) return rule;

      if (depth === path.length - 1) {
        const isBetween = rule.operator === "between";

        let newValue = rule.value;

        if (isBetween) {
          const currentRange = Array.isArray(rule.value)
            ? [...rule.value]
            : [null, null];

          if (Array.isArray(dateValue)) {
            newValue = [
              dateValue[0] ?? currentRange[0],
              dateValue[1] ?? currentRange[1],
            ];
          } else if (dateValue !== null) {
            currentRange[rangeIndex] = dateValue;
            newValue = currentRange;
          }
        } else {
          if (Array.isArray(dateValue)) {
            newValue = dateValue[0] ?? null;
          } else {
            newValue = dateValue ?? null;
          }
        }

        return {
          ...rule,
          value: newValue,
          dateKey: keyId,
        };
      }

      if (Array.isArray(rule.rules)) {
        return {
          ...rule,
          rules: updateRecursive(rule.rules, depth + 1),
        };
      }

      return rule;
    });
  };

  return {
    ...query,
    rules: updateRecursive(query.rules || []),
  };
};

export const collectParametersFromRules = (rules, result = []) => {
  if (!Array.isArray(rules)) return result;

  for (const rule of rules) {
    if (!rule) continue;

    if (Array.isArray(rule.rules)) {
      collectParametersFromRules(rule.rules, result);
      continue;
    }

    const value = rule.value;

    if (value === undefined || value === null) continue;

    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v !== undefined && v !== null && v !== "") {
          result.push(v);
        }
      });
    } else {
      if (value !== "") {
        result.push(value);
      }
    }
  }

  return result;
};
